import { genieJourneySearch, stopByStop_addStopInput, submitSearch_StopByStopTrip } from "../trip_search_scripts";

export function init_preSearch_listeners() {
    $(document).on("input", "[drive-dist]", function() {
        $("[drive-dist]").not(this).val($(this).val());
    });

    $("#stopByStop_submitSearch").on("submit",(event: JQuery.SubmitEvent<any, any, any, any>) => submitSearch_StopByStopTrip(event));
    $("#stopByStop_addStop").on("click", (event: JQuery.ClickEvent<any, any, any, any>) => stopByStop_addStopInput(event));

    $("#tripPlannerAllInOne").on("submit", (event: JQuery.SubmitEvent<any, any, any, any>) => genieJourneySearch(event));
};